import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useNavigate, useParams} from "react-router-dom";
import {AuthContext} from "../../../../config/AuthContext";
import {Button, FloatButton, Select, Switch, Table, TableProps, Tag} from "antd";
import {ColumnsType} from "antd/es/table";
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import {BsPencil, BsUnity} from "react-icons/bs";
import {GetGrups} from "../../../../dao/abp/GetGrups";
import {GetProjecteId} from "../../../../dao/abp/GetProjecteId";
import {BiArrowFromLeft, BiArrowFromRight, BiPlus, BiRefresh} from "react-icons/bi";
import ProjecteModal from "../../projectes/ProjecteModal";
import {GetUsuaris} from "../../../../dao/abp/GerUsuaris";
import {PutUsuariIdPermisProjecte} from "../../../../dao/abp/PutUsuariIdPermisProjecte";

const ProjecteIdProfessorat = () => {
    const {isLoggedIn, userId, user, setBreadCrumb} = useContext(AuthContext);
    const {id_grup, id_projecte, id_usuari} = useParams();
    const [modal, setModal] = useState(false);
    const [selected, setSelected] = useState<any>();

    const navigate = useNavigate();

    const [profes, setProfes] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isLoggedIn) {
            checkGrups();
        }
    }, [id_projecte]);

    async function checkGrups() {
        setLoading(true);
        const da = await GetUsuaris(id_projecte+"");
        console.log(da);
        setProfes(da);


        const data = await GetProjecteId(id_projecte + "",0);

        if (user.tipus === "0") {
            setBreadCrumb([{nom: 'Home', nav: '/home'},
                {nom: 'avaluacio', nav: '/abp'},
                {nom: `${data.nom}`, nav: `/abp/projectes/${data.id}`}], true);

        } else {
            setBreadCrumb([{nom: 'Home', nav: '/home'},
                {nom: 'avaluacio', nav: '/abp'},
                {nom: 'projectes', nav: '/abp/projectes'},
                {nom: `${data.nom}`, nav: `/abp/projectes/${data.id}`}], true);
        }

        setLoading(false);
    }

    const colors = [
        AvaluacioColors.colors.color1,
        AvaluacioColors.colors.color2,
        AvaluacioColors.colors.color3,
        AvaluacioColors.colors.color4,
        AvaluacioColors.colors.color5,
        AvaluacioColors.colors.color6
    ];

    function avaluarGrup(ele: any) {
        navigate(`grups/${ele.id}/avaluacio`);
        checkGrups();
    }

    async function changeProfessorat(ele: any) {
        await PutUsuariIdPermisProjecte(ele.id, id_projecte+"");
        await checkGrups();
    }

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            dataIndex: 'id',
            width: 30,
        },
        {
            key: 'usu',
            dataIndex: 'usu',
            width: 30,
        },
        {
            key: 'nom',
            dataIndex: 'nom',
            width: 30,
        },
        {
            key: 'curs',
            dataIndex: 'curs',
            width: 30,
        },
        {
            key: 'actions',
            dataIndex: 'actions',
            width: 10,
            render: (e, ele) => (
                <>
                    <Switch value={ele.afegit} onChange={() => changeProfessorat(ele)}
                            size="small"/>
                </>
            ),
        },
    ];

    const options = [
        {
            value: 'Pendent',
            label: !(user.tipus === "1" || user.tipus === "0") ? "Pendent" : "Pendent (0)",
        },
        {
            value: 'No Presentat',
            label: !(user.tipus === "1" || user.tipus === "0") ? "No Presentat" : "No Presentat (0)",
        },
        {
            value: 'Malament',
            label: !(user.tipus === "1" || user.tipus === "0") ? "Malament" : "Malament (2)",
        },
        {
            value: 'Suficient',
            label: !(user.tipus === "1" || user.tipus === "0") ? "Suficient" : "Suficient (5)",
        },
        {
            value: 'Bé (*)',
            label: !(user.tipus === "1" || user.tipus === "0") ? "Bé (*)" : "Bé (*) (6,5)",
        },
        {
            value: 'Bé',
            label: !(user.tipus === "1" || user.tipus === "0") ? "Bé" : "Bé (7.5)",
        },
        {
            value: 'Molt bé (*)',
            label: !(user.tipus === "1" || user.tipus === "0") ? "Molt bé (*)" : "Molt bé (*) (9)",
        },
        {
            value: 'Molt bé',
            label: !(user.tipus === "1" || user.tipus === "0") ? "Molt bé" : "Molt bé (10)",
        },
    ];

    const tableProps: TableProps<any> = {
        loading
    };

    return (
        <>
            <Table
                showHeader={false}
                size={"small"}
                title={() => "PROFESSORAT"}
                {...tableProps}
                bordered={true}
                pagination={false}
                columns={columns}
                dataSource={profes}
            />

            { (user.tipus === "1" || user.tipus === "0" ) && !loading && <FloatButton
                shape="circle"
                onClick={() => checkGrups()}
                style={{ insetInlineStart: 97, backgroundColor: AvaluacioColors.colors.color6 }}
                icon={<BiRefresh />}
            />}
        </>
    );
};

export default ProjecteIdProfessorat;
